import type { ReactElement } from 'react'
import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { BaseLayout } from '../../layouts'
import PerformanceHome from './PerformanceHome'
import PerformanceSummaryPage from './PerformanceSummaryPage'


const PerformanceRouter = (): ReactElement | null => {
  const { path } = useRouteMatch()

  return (
    <BaseLayout>
      <Switch>
        <Route exact path={`${path}`}>
          <PerformanceHome />
        </Route>

        <Route exact path={`${path}/summary/:deviceType/:subscriptionId`}>
          <PerformanceSummaryPage />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default PerformanceRouter
